import React from 'react';
import PropTypes from 'prop-types';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { Box } from '@material-ui/core';
import { SchoolIcon, Typography } from '@orijinworks/frontend-commons';
import { isTemplatePlanType } from '../../../../utils/case-plan-create.util';
import { usePlanTypeCardStyles } from './PlanTypeCard.styles';

/**
 * Displays the selected plan type (Resident Plan or Template).
 * Styles match Figma Plan Type=Learner (770:15889) / Template (770:15891).
 */
export const PlanTypeCard = ({ name, description, planTypeKey }) => {
  const classes = usePlanTypeCardStyles();
  const isTemplate = isTemplatePlanType({ key: planTypeKey });
  const IconComponent = isTemplate ? DashboardIcon : SchoolIcon;

  return (
    <Box
      className={`${classes.root} ${
        isTemplate ? classes.rootTemplate : classes.rootResident
      }`}
    >
      <Box
        className={`${classes.avatar} ${
          isTemplate ? classes.avatarTemplate : classes.avatarResident
        }`}
        aria-hidden="true"
      >
        <IconComponent className={classes.icon} />
      </Box>
      <Box className={classes.content}>
        <Typography variant="body1" className={classes.name}>
          {name}
        </Typography>
        <Typography variant="body1" className={classes.description}>
          {description}
        </Typography>
      </Box>
    </Box>
  );
};

PlanTypeCard.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  planTypeKey: PropTypes.string,
};

PlanTypeCard.defaultProps = {
  planTypeKey: undefined,
};

export default PlanTypeCard;
